import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  user: null
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js